module.exports = __webpack_public_path__ + "static/eis_charlie-0ef8939c8a03b3e36e91151bcdc251d5.webp";